import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import createPersistedState from 'vuex-persistedstate';
import CryptoJS from 'crypto-js';
import Vue from 'vue';
import Vuex from 'vuex';
import { name } from "../../package.json";
import pathify from "./pathify";
import modules from "./modules"; // <-- Must be loaded after pathify

Vue.use(Vuex); // Define our encrypt/decrypt functions - called when the store is initialised

var fibCrypto = function fibCrypto(store) {
  store.decrypt = function (data) {
    var bytes = CryptoJS.AES.decrypt(data, process.env.SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  };

  store.encrypt = function (data) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), process.env.SECRET_KEY).toString();
  };
};
/*
 * If not building with SSR mode, you can directly export
 * the Store instantiation (see commented out export below)
 */


var store = new Vuex.Store({
  modules: modules,
  plugins: [createPersistedState({
    key: name
  }), fibCrypto, pathify.plugin],
  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEV
});
export default function () {
  return store;
}
export { store };